import { useEffect, useState } from "react";
import { intl } from "LocaleWrapper";
import { Map, MarkerProps } from "@cofano/cck";
import { Box } from "@mui/material";
import { CustomDialog } from "components/dialogs/Dialogs";
import { request } from "components/utils/Request2";
import styles from "view/maps/utils/Styles.json";
import SimpleLocationMarker from "view/maps/components/markers/SimpleLocationMarker";

const SailingReportLogLocationDialog = ({
	open,
	onClose,
	onLocationSelect,
	defaultPosition,
}: {
	open: boolean;
	onClose: () => void;
	onLocationSelect: (city: string, lat: number, lng: number) => void;
	defaultPosition: { lat: number | null, lng: number | null };
}) => {

	const [ marker, setMarker ] = useState<MarkerProps | null>(null);

	const handleOnClick = (lat: number, lng: number) => {

		setMarker({
			lat: lat,
			lng: lng,
			component: () => <SimpleLocationMarker />,
		});

		request<{ location?: { city?: string } }>({
			url: "geocode/reverse",
			method: "POST",
			body: {
				latitude: lat,
				longitude: lng,
			},
		}).then((response) => {
			onLocationSelect(response.location?.city ?? "", lat, lng);
		});
	};

	useEffect(() => {
		if (open) {
			if (defaultPosition.lat && defaultPosition.lng) {
				setMarker({
					lat: defaultPosition.lat,
					lng: defaultPosition.lng,
					component: () => <SimpleLocationMarker />,
				});
			} else {
				setMarker(null);
			}
		}
	}, [ open ]);

	return (
		<CustomDialog
			open={open}
			onClose={onClose}
			title={intl.formatMessage({ id: "SELECT_LOCATION" })}>
			<Box sx={{ height: 600, width: "100%" }}>
				<Map
					apiKey={"AIzaSyAFEhlhSJ7c85rDGz1JX99veD0sshXx_xs"}
					markers={marker ? [ marker ] : []}
					zoom={12}
					styles={styles}
					onClick={(lat, lng) => handleOnClick(lat, lng)} />
			</Box>
		</CustomDialog>
	);
};

export default SailingReportLogLocationDialog;
